<template>
    <b-badge v-if="value === UserTaskStatus.new" variant="info" class="m-0">
        New
    </b-badge>
    <b-badge v-else-if="value === UserTaskStatus.inProgress" variant="primary" class="m-0">
        In Progress
    </b-badge>
    <b-badge v-else-if="value === UserTaskStatus.complete" variant="success" class="m-0">
        Complete
    </b-badge>
    <b-badge v-else-if="value === UserTaskStatus.expired" variant="warning" class="m-0">
        Expired
    </b-badge>
    <b-badge v-else-if="value === UserTaskStatus.cancelled" variant="danger" class="m-0">
        Cancelled
    </b-badge>
</template>

<script>
import { UserTaskStatus } from '@/models/UserTask';

export default {
    name: "TaskStatusBadge",
    props: {
        value: UserTaskStatus
    },
    data() {
        return {
            UserTaskStatus: UserTaskStatus
        }
    }
}
</script>